module.exports = __webpack_public_path__ + "img/call.9c362638.png";